import React from 'react';

const TermsOfUseContent = () => {
  return (
    <div className="flex flex-col gap-4 p-4">
      <h2 className="text-xl font-bold mb-4">TERMO DE USO – PLATAFORMA DRDERMA TELEMEDICINA</h2>

      <p>
        Bem-vindo(a) à DRDERMA TELEMEDICINA LTDA, pessoa jurídica inscrita no CNPJ nº
        52.471.587/0001-10 ("DRDERMA"), responsável pela disponibilização da plataforma digital
        que conecta pacientes a médicos regularmente inscritos no CRM, permitindo a realização de
        consultas médicas online (videoconferência) e offline (análise assíncrona de vídeos, fotos e
        mensagens).
      </p>

      <p>
        Ao acessar, navegar ou utilizar a plataforma, o usuário declara que leu, compreendeu e
        concorda integralmente com este Termo de Uso e com a Política de Privacidade da
        DRDERMA.
      </p>

      <h3 className="text-lg font-bold mt-4">1. OBJETO DO TERMO</h3>

      <p>
        <strong>1.1.</strong> Este Termo regula o uso da plataforma DRDERMA pelo paciente, estabelecendo
        direitos e obrigações referentes:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>ao agendamento e realização de consultas online;</li>
        <li>ao envio de informações, vídeos e fotos para consultas offline;</li>
        <li>aos pagamentos, reembolsos e cancelamentos;</li>
        <li>à responsabilidade da DRDERMA e dos médicos;</li>
        <li>à proteção de dados pessoais;</li>
        <li>à conduta esperada dos usuários.</li>
      </ul>

      <p>
        <strong>1.2.</strong> A DRDERMA atua como provedora de tecnologia, disponibilizando o ambiente
        digital para que médicos e pacientes realizem consultas, não participando do ato
        médico.
      </p>

      <h3 className="text-lg font-bold mt-4">2. NATUREZA DO SERVIÇO PRESTADO PELA DRDERMA</h3>

      <p>
        <strong>2.1.</strong> A DRDERMA fornece infraestrutura tecnológica, incluindo:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>ambiente seguro de videoconferência;</li>
        <li>sistema de envio e recebimento de mensagens, imagens e vídeos;</li>
        <li>área para prescrição médica digital (quando autorizada pelo médico);</li>
        <li>gestão de pagamentos;</li>
        <li>notificações e suporte técnico básico.</li>
      </ul>

      <p>
        <strong>2.2.</strong> A DRDERMA não se responsabiliza por:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>diagnóstico, conduta, parecer ou prescrição médica;</li>
        <li>recomendações clínicas, prognósticos ou decisões terapêuticas;</li>
        <li>eventuais efeitos ou ineficácia de tratamentos sugeridos pelo médico;</li>
        <li>compatibilidade dos equipamentos do usuário.</li>
      </ul>

      <p>
        <strong>2.3.</strong> Todo e qualquer ato médico é de responsabilidade exclusiva do médico contratado,
        devidamente inscrito no Conselho Regional de Medicina.
      </p>

      <h3 className="text-lg font-bold mt-4">3. CADASTRO DO USUÁRIO</h3>

      <p>
        <strong>3.1.</strong> Para utilizar a plataforma, o usuário deve fornecer informações verdadeiras, mantendo
        seus dados atualizados.
      </p>

      <p>
        <strong>3.2.</strong> A utilização de dados falsos, incompletos ou de terceiros autoriza a DRDERMA a
        suspender ou encerrar o acesso imediatamente.
      </p>

      <p>
        <strong>3.3.</strong> O paciente é responsável por manter sigilo sobre seus dados de acesso.
      </p>

      <h3 className="text-lg font-bold mt-4">4. CONSULTAS ONLINE</h3>

      <p>
        <strong>4.1.</strong> As consultas online são realizadas via videoconferência no dia e horário escolhidos na
        plataforma.
      </p>

      <p>
        <strong>4.2.</strong> O paciente é responsável por possuir:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>internet estável;</li>
        <li>dispositivo compatível;</li>
        <li>ambiente adequado para a consulta.</li>
      </ul>

      <p>
        <strong>4.3.</strong> Caso o paciente não compareça, aplicar-se-ão as regras de cancelamento deste Termo.
      </p>

      <h3 className="text-lg font-bold mt-4">5. CONSULTAS OFFLINE</h3>

      <p>
        <strong>5.1.</strong> Nas consultas offline o paciente envia:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>fotos;</li>
        <li>vídeos explicativos;</li>
        <li>descrição textual do problema.</li>
      </ul>

      <p>
        <strong>5.2.</strong> O médico terá até 24 horas para analisar o conteúdo e responder.
      </p>

      <p>
        <strong>5.3.</strong> O paciente declara compreender que:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>a consulta ocorre sem interação em tempo real;</li>
        <li>a avaliação depende da qualidade das imagens enviadas;</li>
        <li>poderá ser recomendada consulta presencial caso haja limitação diagnóstica.</li>
      </ul>

      <h3 className="text-lg font-bold mt-4">6. PAGAMENTOS E NOTAS FISCAIS</h3>

      <p>
        <strong>6.1.</strong> O pagamento das consultas é feito pela plataforma via PIX ou cartão de crédito.
      </p>

      <p>
        <strong>6.2.</strong> O paciente receberá duas notas fiscais, pois se tratam de serviços distintos:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>nota fiscal da DRDERMA – referente ao serviço tecnológico (telemedicina);</li>
        <li>nota fiscal do médico – referente ao ato médico (serviço de saúde).</li>
      </ul>

      <p>
        <strong>6.3.</strong> Somente a nota fiscal do médico poderá ser utilizada para dedução no imposto de renda,
        conforme legislação vigente.
      </p>

      <h3 className="text-lg font-bold mt-4">7. CANCELAMENTOS E REEMBOLSOS</h3>

      <p>
        <strong>7.1. Consultas Online:</strong>
      </p>
      <p className="pl-4">
        Cancelamento com reembolso integral se solicitado até 24 horas antes da data/hora
        agendada.
      </p>

      <p>
        <strong>7.2. Consultas Offline:</strong>
      </p>
      <p className="pl-4">
        Cancelamento possível somente antes do envio das informações (fotos, vídeos, mensagens).
      </p>

      <p>
        <strong>7.3.</strong> Após o início da prestação do serviço pelo médico, não há reembolso.
      </p>

      <p>
        <strong>7.4.</strong> Em cancelamentos realizados pelo médico ou pela DRDERMA por motivo técnico, o
        paciente poderá optar por:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>reagendar; ou</li>
        <li>receber reembolso integral.</li>
      </ul>

      <p>
        <strong>7.5.</strong> Os estornos de valores de PIX podem levar algumas horas para aparecerem nos
        extratos e saldos das contas de onde foram realizados, os estornos de valores pagos por
        cartão de crédito, podem levar mais tempo até serem processados pelas instituições
        financeiras envolvidas.
      </p>

      <h3 className="text-lg font-bold mt-4">8. RESPONSABILIDADE DA PLATAFORMA</h3>

      <p>
        <strong>8.1.</strong> A DRDERMA não garante:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>cura;</li>
        <li>sucesso terapêutico;</li>
        <li>efetividade do tratamento;</li>
        <li>diagnóstico conclusivo.</li>
      </ul>

      <p>
        <strong>8.2.</strong> A DRDERMA não será responsável por:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>falhas de conexão ou equipamentos do usuário;</li>
        <li>atraso do usuário na consulta;</li>
        <li>danos decorrentes do ato médico;</li>
        <li>decisões clínicas tomadas pelo médico.</li>
      </ul>

      <p>
        <strong>8.3.</strong> Eventual responsabilidade da plataforma, se reconhecida judicialmente, estará limitada
        ao valor das taxas de serviço recebidas no mês anterior ao fato.
      </p>

      <h3 className="text-lg font-bold mt-4">9. RESPONSABILIDADE DO USUÁRIO</h3>

      <p>
        <strong>9.1.</strong> O usuário concorda em:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>fornecer informações verdadeiras;</li>
        <li>não omitir dados relevantes;</li>
        <li>não enviar imagens de terceiros;</li>
        <li>não usar a plataforma para fins ilícitos ou abusivos.</li>
      </ul>

      <h3 className="text-lg font-bold mt-4">10. PROTEÇÃO DE DADOS – LGPD</h3>

      <p>
        <strong>10.1.</strong> Os dados pessoais e sensíveis do paciente serão tratados conforme a Lei Geral de
        Proteção de Dados (Lei 13.709/2018).
      </p>

      <p>
        <strong>10.2.</strong> A DRDERMA adota medidas técnicas e administrativas adequadas para proteger dados
        de: acesso não autorizado; perda; vazamento e alteração indevida.
      </p>

      <p>
        <strong>10.3.</strong> O paciente poderá solicitar: acesso aos dados; correção; anonimização e revogação do
        consentimento.
      </p>

      <h3 className="text-lg font-bold mt-4">11. COMUNICAÇÕES OFICIAIS</h3>

      <p>
        <strong>11.1.</strong> Toda comunicação será feita:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>via e-mail cadastrado na plataforma;</li>
        <li>por mensagens internas do sistema.</li>
      </ul>

      <h3 className="text-lg font-bold mt-4">12. ALTERAÇÕES DO TERMO</h3>

      <p>
        <strong>12.1.</strong> A DRDERMA poderá atualizar este Termo mediante aviso prévio por e-mail ou dentro da
        plataforma.
      </p>

      <p>
        <strong>12.2.</strong> A continuidade do uso do serviço implica aceitação integral da nova versão.
      </p>

      <h3 className="text-lg font-bold mt-4">13. FORO</h3>

      <p>
        <strong>13.1.</strong> As partes elegem o Foro da Comarca do Rio de Janeiro – RJ, com renúncia a qualquer
        outro, por mais privilegiado que seja.
      </p>

      <h3 className="text-lg font-bold mt-4">14. ACEITE DIGITAL</h3>

      <p>
        <strong>14.1.</strong> Ao clicar em "ACEITO", o usuário declara ter lido e compreendido todas as
        cláusulas deste Termo, concordando integralmente com sua aplicação.
      </p>
    </div>
  );
};

export default TermsOfUseContent;
